import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './PaymentPorterPage.css';
import './ProfileIATAPage.css';
import pmmService from '../services/paymentMigrationManagerService';
import { formatDateTime } from '../utils/datetime';

const statusColour = (s) => {
    if (s === 'SUCCESS') return '#16a34a';
    if (s === 'ERROR')   return '#dc2626';
    if (s === 'SKIPPED') return '#d97706';
    return '#6b7280';
};

const PaymentMigrationManagerRunDetailPage = () => {
    const { id, runRef } = useParams();
    const navigate = useNavigate();
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        pmmService.getRunDetail(id, decodeURIComponent(runRef))
            .then(res => setReservations(res.data?.reservations || []))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [id, runRef]);

    const summary = reservations.reduce((acc, r) => {
        acc[r.status] = (acc[r.status] || 0) + 1;
        return acc;
    }, {});

    return (
        <div className="pi-page">
            <div className="pi-header">
                <div className="pi-header-left">
                    <button className="pi-back-btn" onClick={() => navigate(`/apps/payment-migration-manager/${id}?tab=runs`)}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Run History
                    </button>
                    <div className="pi-title-block">
                        <h1 className="pi-title">Run Detail</h1>
                        <p className="pi-subtitle" style={{fontFamily:'monospace', fontSize:12}}>{decodeURIComponent(runRef)}</p>
                    </div>
                </div>
            </div>

            {!loading && reservations.length > 0 && (
                <div style={{display:'flex', gap:16, padding:'0 0 16px', flexWrap:'wrap'}}>
                    {Object.entries(summary).map(([status, count]) => (
                        <div key={status} style={{padding:'10px 16px', background:'#f9fafb', borderRadius:8, textAlign:'center'}}>
                            <div style={{fontSize:20, fontWeight:700, color: statusColour(status)}}>{count}</div>
                            <div style={{fontSize:12, color:'#6b7280'}}>{status}</div>
                        </div>
                    ))}
                </div>
            )}

            <div className="pi-list-panel">
                {loading ? (
                    <div style={{padding:20}}>Loading…</div>
                ) : reservations.length === 0 ? (
                    <div className="pi-empty-title" style={{padding:20}}>No reservations found for this run.</div>
                ) : (
                    <table className="pi-table">
                        <thead>
                            <tr>
                                <th>Reservation ID</th>
                                <th>Confirmation</th>
                                <th>Status</th>
                                <th>Matched Criteria</th>
                                <th>Actions Applied</th>
                                <th>Error / Skip Reason</th>
                                <th>Processed At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reservations.map(r => {
                                const criteria = r.matched_criteria ? JSON.parse(r.matched_criteria) : [];
                                const actions  = r.actions_applied  ? JSON.parse(r.actions_applied)  : [];
                                return (
                                    <tr key={r.id}>
                                        <td style={{fontFamily:'monospace', fontSize:12}}>{r.reservation_id}</td>
                                        <td>{r.confirmation_number || '—'}</td>
                                        <td>
                                            <span style={{color: statusColour(r.status), fontWeight:600}}>{r.status}</span>
                                        </td>
                                        <td style={{fontSize:11}}>{criteria.join(', ') || '—'}</td>
                                        <td style={{fontSize:11}}>{actions.join(', ') || '—'}</td>
                                        <td style={{fontSize:11, color:'#6b7280'}}>{r.error_message || r.skip_reason || '—'}</td>
                                        <td style={{fontSize:12}}>{formatDateTime(r.processed_at)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default PaymentMigrationManagerRunDetailPage;
